import BaseReport from "./BaseReport"

export default class Posts extends BaseReport {
    constructor() {
        const reportUrl = '/backend/references/posts/'
        super(reportUrl)
    }
}
